import './index.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/smSupplierManagement';
import {
  BankInfo,
  BaseInfo,
  Contact,
  QualifiedFile,
  ServiceInfo,
  SupplierContracts,
  SupplierEmployees,
  supplierDetailHOC,
} from '../components/Detail';
import { DetailProps } from '../components/Detail/supplierDetailHOC';
import classnames from 'classnames';
import { Row, Col } from '@beehive/components';
import { CardPage } from 'components';
import Header from './Header';
import PageFooter from '@mpc/common/src/features/PageFooter';

export const BANK_INFO_KEYS = {
  bank_name: {},
  bank_number: {},
};

class CompanyInfoDetail extends Component<DetailProps, any> {
  getAttachementDownloadUrl = (attachId: number, withDownload?: boolean) => {
    const { getAttachementDownloadLink } = this.props;

    if (getAttachementDownloadLink) {
      return getAttachementDownloadLink(attachId, withDownload);
    }

    return `api/v1/attachments/${attachId}?download=attachment`;
  }

  public render() {
    const {
      prefixCls,
      history,
      location,
      data,
      data: { permit_buttons },
      readOnly = true,
      getAttachementDownloadLink,
    } = this.props;

    const classes = classnames({
      [`${prefixCls}-detail`]: true,
    });

    return (
      <CardPage className={classes}>
        <Header
          history={history}
          location={location}
          permitButtons={permit_buttons}
          readOnly={readOnly}
        />
        <Row gutter={16}>
          <Col span={11}>
            <BaseInfo data={data} />
          </Col>
          <Col span={13}>
            <QualifiedFile getAttachementDownloadLink={this.getAttachementDownloadUrl} {...data} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <ServiceInfo {...data} />
          </Col>
        </Row>

        {data.showSupplierContracts ? (
          <Row gutter={16}>
            <Col span={15} className="audit-info-col">
              <SupplierContracts {...data} />
            </Col>
            <Col span={9}>
              <Contact {...data} />
              <BankInfo {...data} bankInfoKeys={BANK_INFO_KEYS} />
            </Col>
          </Row>
        ) : (
          <Row gutter={16} type="flex">
            <Col span={12}>
              <Contact {...data} />
            </Col>
            <Col span={12}>
              <BankInfo {...data} bankInfoKeys={BANK_INFO_KEYS} />
            </Col>
          </Row>
        )}

        <Row>
          <Col span={24}>
            <SupplierEmployees {...data} />
          </Col>
        </Row>

        <PageFooter />
      </CardPage>
    );
  }
}

const mapStateProps = (state: any, ownProps: any) => {
  const data = ownProps.data || state.smSupplierManagement.detail;
  return {
    data,
  };
};

export function mapDispatchToProps(
  dispatch: Dispatch<actions.SupplierManagementActions>,
  ownProps: any,
) {
  return bindActionCreators(
    {
      getDetail: ownProps.getDetail || actions.getDetail,
    },
    dispatch,
  );
}

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(supplierDetailHOC(CompanyInfoDetail));
